import { useState } from 'react';
import { IColumnData, IRowData } from '@components/simple-table/types';
import { formatDateTime } from '@/lib/utils/date';
import { useTranslation } from 'react-i18next';
import { IAuditColumnsVisibilityType } from '@/containers/pages/statistics/types';
import { Description } from '@/containers/pages/statistics/components/tabs/audit/components/table/descriptionColumn';
import { User } from '../components/table/userColumn';
import {
  NewValuesCell,
  OldValuesCell
} from '@/containers/pages/statistics/components/tabs/audit/components/table/cells/ValuesCell';

export const useGetColumns = (columnVisibility: IAuditColumnsVisibilityType) => {
  const { t } = useTranslation();

  const columnsData: IColumnData[] = [
    {
      width: 'auto',
      dataIndex: 'Name',
      title: t('statistics.user'),
      hideColumn: columnVisibility['UserName'],
      render: (item: IRowData) => <User UserName={item?.UserName} UserId={item?.UserId} />
    },
    {
      width: 'auto',
      dataIndex: 'Date',
      title: t('statistics.date_time'),
      hideColumn: columnVisibility['Date'],
      render: (item: IRowData) => formatDateTime(item?.Date)
    },
    {
      width: 'auto',
      dataIndex: 'ActionType',
      title: t('statistics.action'),
      hideColumn: columnVisibility['ActionType'],
      render: (item: IRowData) => item?.TypeName || '-'
    },
    {
      width: 'auto',
      dataIndex: 'Description',
      title: t('statistics.description'),
      hideColumn: columnVisibility['Description'],
      render: (item: IRowData) => (
        <Description DescriptionTitle={item?.Description} Titles={item?.Titles} />
      )
    },
    {
      width: 'auto',
      dataIndex: 'Ip',
      title: t('statistics.ip'),
      hideColumn: columnVisibility['Ip'],
      render: (item: IRowData) => (item?.Ip ? item?.Ip : t('noData'))
    },
    {
      width: 'auto',
      dataIndex: 'OldValue',
      title: t('statistics.newValue'),
      hideColumn: columnVisibility['OldValue'],
      render: NewValuesCell
    },
    {
      width: 'auto',
      dataIndex: 'OldValues',
      title: t('statistics.oldValues'),
      hideColumn: columnVisibility['OldValue'],
      render: OldValuesCell
    }
    // {
    //   width: '100px',
    //   dataIndex: 'Action',
    //   title: '',
    //   hideColumn: false,
    //   render: (item: IRowData) => <AuthActionsDropdown item={item} />
    // }
  ];

  const [columns, setColumns] = useState<IColumnData[]>(columnsData);

  return { columns, setColumns };
};
